import { DEFAULT_REMESH_SETTINGS, POLY_COUNT } from '../constants'
import { threeDStudioStore } from '../index'

const setRemeshState = (patch) => {
  threeDStudioStore.setState((state) => ({
    remeshSettings: { ...state.remeshSettings, ...patch },
  }))
}

/**
 * Resets all remesh settings to their default values.
 */
export const clearSettings = () => {
  threeDStudioStore.setState({
    remeshSettings: { ...DEFAULT_REMESH_SETTINGS },
  })
}

/**
 * Sets the smart low poly flag
 * @param {boolean} isSmartLowPoly - Whether smart low poly is enabled
 */
export const setIsSmartLowPoly = (isSmartLowPoly) => {
  setRemeshState({ isSmartLowPoly })
}

/**
 * Sets the polygon type
 * @param {string|undefined} polygonType - One of: "quadrilateral", "triangle" or undefined
 */
export const setPolygonType = (polygonType) => {
  setRemeshState({ polygonType })
}

/**
 * Sets the face level
 * @param {string} faceLevel - One of: "low", "medium", "high"
 */
export const setFaceLevel = (faceLevel) => {
  const { schema, remeshSettings } = threeDStudioStore.getState()
  const { polygonType } = remeshSettings
  const enhancedModelSchema = schema?.enhancedModelSchema
  const targetPolycountSchema = enhancedModelSchema?.input_schema?.properties?.target_polycount

  if (targetPolycountSchema) {
    const { minimum, maximum, default: defaultValue } = (() => {
      if (targetPolycountSchema?.oneOf) {
        const matched = targetPolycountSchema.oneOf.find(
          entry => entry?.if?.properties?.polygon_type?.const === polygonType,
        )

        if (matched) {
          return matched?.then?.properties?.target_polycount
        }
      }

      return targetPolycountSchema
    })()
    const targetPolyCount = {
      [POLY_COUNT.LOW]: minimum,
      [POLY_COUNT.MEDIUM]: defaultValue,
      [POLY_COUNT.HIGH]: maximum,
    }[faceLevel]

    setRemeshState({
      faceLevel,
      targetPolycount: targetPolyCount,
    })

    return
  }

  setRemeshState({ faceLevel })
}

/**
 * Sets the target polygon count
 * @param {number|string} targetPolycount - Number or empty string
 */
export const setTargetPolycount = (targetPolycount) => {
  setRemeshState({ targetPolycount })
}
